module.exports = __webpack_public_path__ + "static/media/Logo_GV.d412299b.png";